import React, { useEffect, useState } from "react";
import "./Option.css";

interface QuestionProps {
  id: number;
  option: OptionInfoProps;
  handleAnswer: (selectedAnswer: number) => void;
  isCorrect: boolean;
  state: number | null;
  showHint: boolean;
}

interface OptionInfoProps {
  name: string;
  description: string;
  hint: string;
  colour: string;
  icon: string;
}

const Option: React.FC<QuestionProps> = ({
  id,
  option,
  handleAnswer,
  isCorrect,
  state,
  showHint,
}) => {
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    if (state === 0 || state === null) {
      setAnimationClass("");
    }

    if (state === 1) {
      const animation = isCorrect ? "correct" : "incorrect";
      setAnimationClass(animation);
    }

    if (state === 2) {
      setAnimationClass("animate");
    }

    if (state === 3) {
      setAnimationClass("come-back");
    }
  }, [state, isCorrect]);

  const onClickHandler = () => {
    handleAnswer(id);
  };

  /*
<div className={`option ${animationClass}`} onClick={onClickHandler}>
  */

  return (
    <div className={`option ${id === 0 ? 'with-border' : ''}`}>
      <div className={`option-background`}
          style={{
            backgroundImage: `url('/icons/${option.icon}')`,
            backgroundColor: option.colour,
          }}
      ></div>
      <div className={`option-card ${animationClass}`} onClick={onClickHandler}>
        <div className="title">{option.name}</div>
        <div className="hint">{showHint ? option.hint : " "}</div>
        <div className="description">{option.description}</div>
      </div>
    </div>
  );
};

export default Option;
